import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=7b0eb802&"
import script from "./Projects.vue?vue&type=script&lang=js&"
export * from "./Projects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b0eb802')) {
      api.createRecord('7b0eb802', component.options)
    } else {
      api.reload('7b0eb802', component.options)
    }
    module.hot.accept("./Projects.vue?vue&type=template&id=7b0eb802&", function () {
      api.rerender('7b0eb802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Pages/Projects.vue"
export default component.exports